export enum CustomerFormFieldApiTags {
  createDefaultFields = "CreateDefaultFields",
  formFields = "FormFields",
}
